import React, { useState } from "react";
import SubInputBarraBusqueda from "./components/SubInputBarraBusqueda";
import SubResultadosBarraBusqueda from "./components/SubResultadosBarraBusqueda";
import { getCursosEmpaginados } from "../../pages/publico/Cursos/services/cursosNoCompradosService.jsx";

export default function UniversalBarraBusqueda({ vCategoriasObtenidas }) {
  const [searchText, setSearchText] = useState("");
  const [cursosBuscados, setCursosBuscados] = useState([]);  // Solo para cursos
  const [vIsFocus, setVIsFocus] = useState(false);

  const handleSearch = (text) => {
    setSearchText(text);

    if (text.trim() === "") {
      // Si el input está vacío, limpiamos los cursos buscados
      setCursosBuscados([]);
    } else {
      // Buscar cursos al escribir
      getCursosEmpaginados(1, 50, [])  // Pedimos varios para filtrar mejor
        .then(response => response.json())
        .then(result => {
          if (result.detail["acción"] === "MOSTRAR_CURSOS") {
            const cursos = result.detail.datos.cursos;

            // Filtrado simple en frontend
            const filtrados = cursos.filter(curso =>
              curso.nombre.toLowerCase().includes(text.toLowerCase())
            );

            setCursosBuscados(filtrados);
          } else {
            setCursosBuscados([]);
          }
        })
        .catch(err => {
          console.log("Error al buscar cursos", err);
          setCursosBuscados([]);
        });
    }
  };

  return (
    <div data-figma-id="5381:19949" className="menu-busqueda">
      <SubInputBarraBusqueda
        onSearch={handleSearch}
        setVIsFocus={setVIsFocus}
      />
      <SubResultadosBarraBusqueda
        datosAMostrar={searchText.trim() === "" ? vCategoriasObtenidas : cursosBuscados}
        vIsFocus={vIsFocus}
        esBusquedaCursos={searchText.trim() !== ""}
      />
    </div>
  );
}
